import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

if (!customElements.get('tabs-element')) {
    customElements.define('tabs-element', class extends HTMLElement {

        connectedCallback() {
            this.navContainer = this.querySelector('.tabs-element__nav');
            this.templatesContainer = this.querySelector('.tabs-element__templates');
            this.contentContainer = this.querySelector('.tabs-element__content');

            this.swiper = null;

            this.initTabs();
        }

        getSettings() {
            const configEl = this.querySelector('[data-slider-settings]');
            if (!configEl) return {};

            try {
                return JSON.parse(configEl.textContent);
            } catch (e) {
                console.warn('Invalid slider settings JSON', e);
                return {};
            }
        }

        initTabs() {
            const navTemplates = this.querySelectorAll('.tabs-element__nav-template');

            this.navContainer.innerHTML = '';

            navTemplates.forEach((template, index) => {
                const clone = template.content.cloneNode(true);

                const btn = clone.querySelector('.icons-list__item');

                if (index === 0) {
                    btn.classList.add('is-active');
                }

                this.navContainer.appendChild(clone);
            });

            this.btns = this.querySelectorAll('.icons-list__item');

            this.btns.forEach(btn => {
                btn.addEventListener('click', (e) => this.switchTab(e.currentTarget));
            });

            if (this.btns[0]) {
                this.loadTab(this.btns[0].dataset.target);
            }
        }

        switchTab(clickedBtn) {
            this.btns.forEach(b => b.classList.remove('is-active'));
            clickedBtn.classList.add('is-active');

            const targetId = clickedBtn.getAttribute('data-target');
            this.loadTab(targetId);
        }

        loadTab(tabId) {
            const template = this.templatesContainer.querySelector(`#${tabId}`);

            if (!template) return;

            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }

            this.contentContainer.innerHTML = '';

            const clone = template.content.cloneNode(true);

            this.contentContainer.appendChild(clone);

            const swiperEl = this.contentContainer.querySelector('.swiper');

            if (swiperEl) {
                this.initSwiper(swiperEl);
            }
        }

        initSwiper(swiperEl) {
            const sliderSettings = this.getSettings();

            this.swiper = new Swiper(swiperEl, {
                observer: true,
                observeParents: true,

                slidesPerView: sliderSettings.slidesPerViewMobile,
                spaceBetween: sliderSettings.spaceBetweenMobile,
                loop: false,
                grabCursor: true,
                watchSlidesProgress: true,

                ...(sliderSettings.autoplay && {
                    autoplay: {
                        delay: sliderSettings.autoplayDelay * 1000,
                        disableOnInteraction: false,
                    }
                }),

                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: true,
                    dynamicBullets: true
                },

                breakpoints: {
                    768: {
                        slidesPerView: sliderSettings.slidesPerViewTablet,
                        spaceBetween: sliderSettings.spaceBetween
                    },
                    1200: {
                        slidesPerView: sliderSettings.slidesPerView,
                        spaceBetween: sliderSettings.spaceBetween
                    }
                }
            });
        }
    });
}